import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { CloseOutlined, ExportOutlined, SearchOutlined } from "@ant-design/icons";
import { 
  Breadcrumb, 
  Button, 
  Col, 
  DatePicker, 
  Drawer,
  Form, 
  Input, 
  Result, 
  Row, 
  Spin, 
  Table 
} from "antd";
import moment from "moment";
import { Util } from "common/util";
import { getAllocationSeniorityAndSeverancePay } from "services/payroll_report";


export default function MonthlyAllocationSeniorityAndSeverancePay() {
  const [data, setData] = React.useState({payrolls: []});
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const pathName = "/reports/payroll/monthly_allocation_seniority_and_severance_pay";
  const params = new URLSearchParams(document.location.search);
  let timer = null;

  const onBack = () => {
    navigate("/reports/payroll");
  };

  React.useMemo(() => {
    const params = new URLSearchParams(document.location.search);
    if (!params.get("date")) {
      params.set("date", moment().format("YYYY-MM"));
    }
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  }, []);

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line
  }, []);

  const fetchList = () => {
    const params = new URLSearchParams(document.location.search);
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");
    setLoading(true);
    getAllocationSeniorityAndSeverancePay(option)
      .then((response) => {
        if (response) {
          setData(response);
        }
      })
      .catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));
  };

  const onSearch = (e) => {
    clearTimeout(timer);
    const value = e.target.value;
    const params = new URLSearchParams(document.location.search);

    if (value) {
      params.set("search", value)
    } else {
      params.delete("search");
    }

    Util.getInstance().pushParamsToURL(pathName, params.toString());;
    timer = setTimeout(() => {
      fetchList();
    }, 1000);
  };

  return (
    <>
      <Row style={styles.breadCream}>
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              {t("text_dashboard")}
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={onBack} style={{ cursor: "pointer" }}>
              {t("text_payroll_report")}
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#1d8747" }}>
              Monthly Allocation Seniority And Severance Pay
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row style={{ padding: 15 }} id="header-report-table">
        <Col span={12}>
          <Title subTitle={"Monthly Allocation Seniority And Severance Pay"} />
        </Col>
        <Col
          span={12}
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 5,
          }}
        >
          <Input
            placeholder={t("text_search_by_employee")}
            defaultValue={params.get("search")}
            prefix={<SearchOutlined />}
            style={styles.generalSearch}
            allowClear={true}
            onChange={onSearch}
          />
          <DatePickerFilter
            fetchList={fetchList}
            pathName={pathName}
            dateFormat={"MM/YYYY"}
            datePlaceholder={t("text_mm_yyyy")}
            pickerDate={"month"}
          />
          <ExportButton />
        </Col>
      </Row>

      <div id="report-table">
        <Table
          bordered
          dataSource={data.payrolls}
          pagination={false}
          scroll={data.payrolls?.length > 0 ? {
            y: window.innerHeight - 310,
          } : undefined}
          rowKey={(record) => `${record.payrollId}`}
          columns={[
            {
              title: "Name",
              dataIndex: "employeeName",
              key: "employeeName"
            },
            {
              title: "EMP#",
              dataIndex: "employeeCode",
              key: "employeeCode"
            },
            {
              title: "Position",
              dataIndex: "position",
              key: "position"
            },
            {
              title: "Duty Station",
              dataIndex: "dutyStation",
              key: "dutyStation"
            },
            {
              title: "D.O.E",
              dataIndex: "joinDate",
              key: "joinDate",
              render: joinDate => moment(joinDate).format("DD/MM/YYYY")
            },
            {
              title: "Pay Basic",
              dataIndex: "grossSalary",
              key: "grossSalary",
              align: "right",
              render: (grossSalary) => Util.getInstance().formatCurrency(grossSalary)
            },
            {
              title: <div style={{ textAlign: "center" }}>{`Seniority payment ${moment(params.get("date")).format("MMMM YY")}`}</div>,
              dataIndex: "accrualSeniority",
              key: "accrualSeniority",
              align: "right",
              render: (accrualSeniority) => accrualSeniority ? Util.getInstance().formatCurrency(accrualSeniority) : ""
            },
            {
              title: <div style={{ textAlign: "center" }}>{`Severance Pay ${moment(params.get("date")).format("MMMM YY")}`}</div>,
              dataIndex: "accrualSeverancePay",
              key: "accrualSeverancePay",
              align: "right",
              render: (accrualSeverancePay) => accrualSeverancePay ? Util.getInstance().formatCurrency(accrualSeverancePay) : ""
            },
            {
              title: <div style={{ textAlign: "center" }}>{`Uptodate Severance pay ${moment(params.get("date")).format("MMMM YY")}`}</div>,
              dataIndex: "balanceSeverancePay",
              key: "balanceSeverancePay",
              align: "right",
              render: balanceSeverancePay => balanceSeverancePay ? Util.getInstance().formatCurrency(balanceSeverancePay) : ""
            }
          ]}
          loading={loading}
        />
      </div>
    </>
  );
}

function Title({ subTitle }) {
  return <span id="title-table-report">{subTitle}</span>;
}

function ExportButton() {
  const [visible, setVisible] = React.useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const onShow = () => {
    setVisible(true);
  };

  return (

    <>
      <Button
        icon={<ExportOutlined />}
        onClick={onShow}
        style={{ marginLeft: 10 }}
      >
        {t("text_export")}
      </Button>
      <Drawer
        title={
          <div style={styles.headerFilter}>
            <div>{t("text_export_report")}</div>
            <div>
              <CloseOutlined onClick={onClose} />
            </div>
          </div>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
      >
        {visible ? <ExportExcelFile /> : null}
      </Drawer>
    </>
  );
}

const ExportExcelFile = () => {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");

    option["isExport"] = true;
    getAllocationSeniorityAndSeverancePay(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title={"Successfully exported Monthly Allocation Seniority And Severance Pay"}
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

const DatePickerFilter = ({
  pathName,
  fetchList,
  dateFormat,
  datePlaceholder,
  pickerDate,
}) => {
  const queryParams = new URLSearchParams(document.location.search);
  const onChangeDate = (value, valueString) => {
    const dateString = valueString.split("/");
    if (value) {
      if (dateString.length === 3) {
        queryParams.set("date", Util.getInstance().formatDateForMYSQL(value));
      } else {
        queryParams.set("date", moment(value).format("YYYY-MM"));
      }
    } else {
      queryParams.delete("date");
    }
    Util.getInstance().pushParamsToURL(pathName, queryParams.toString());
    fetchList();
  };

  return (
    <>
      <Form style={{ marginLeft: "8px" }}>
        <DatePicker
          name="date"
          placeholder={`${datePlaceholder}`}
          format={`${dateFormat}`}
          style={{ marginLeft: "8px", width: "180px" }}
          defaultValue={
            queryParams.get("date") && moment(queryParams.get("date"))
          }
          picker={`${pickerDate}`}
          allowClear={false}
          onChange={onChangeDate}
        />
      </Form>
    </>
  );
};

const styles = {
  formInline: {
    width: 203,
    display: "inline-block",
    textAlign: "left",
    marginRight: 5,
    marginBottom: 0,
    marginTop: 0,
  },
  generalSearch: {
    width: 203,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
};
